import { useFormContext, useForm } from 'react-hook-form';

function useFormField() {
    const formContext = useFormContext();
    const formMethods = useForm({ mode: "onTouched" });
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Typings are incorrect for 'useFormContext', it returns null when not wrapped in a FormProvider
    if (formContext) {
        return Object.assign({}, formContext);
    }
    return Object.assign({}, formMethods);
}

export { useFormField };
//# sourceMappingURL=useFormField.js.map
